export default __webpack_public_path__ + "static/kutu-tasarimi-ambalaj-bicak-izi-cizim-70e06e74ec429f244f84a1b1f2e03ead.jpg";